import React, { useState } from 'react';
import styled from 'styled-components';
import Footer from '../components/Footer';

const Container = styled.div`
  background: #ffffff;
  min-height: 100vh;
  color: #000000;
`;

const HeroSection = styled.div`
  background: linear-gradient(135deg, #2d5a27 0%, #1a3518 100%);
  color: #ffffff;
  padding: 48px 16px 40px;
  text-align: center;
`;

const HeroContent = styled.div`
  max-width: 700px;
  margin: 0 auto;
`;

const PageTitle = styled.h1`
  font-size: 1.75rem;
  font-weight: 700;
  margin: 0 0 12px 0;
  letter-spacing: -0.02em;

  @media (max-width: 768px) {
    font-size: 1.5rem;
  }
`;

const PageSubtitle = styled.p`
  font-size: 0.95rem;
  color: rgba(255, 255, 255, 0.9);
  line-height: 1.5;
  margin: 0;
`;

const ContentSection = styled.div`
  padding: 48px 16px;
  max-width: 900px;
  margin: 0 auto;
`;

const StorySection = styled.div`
  margin-bottom: 48px;
`;

const SectionTitle = styled.h2`
  font-size: 1.25rem;
  font-weight: 700;
  margin-bottom: 16px;
  color: #1a1a2e;
  text-align: center;
`;

const StoryContent = styled.div`
  font-size: 0.9rem;
  line-height: 1.7;
  color: #444;

  p {
    margin-bottom: 16px;
  }

  strong {
    color: #1a1a2e;
  }
`;

const FounderSection = styled.div`
  background: #f8f9fa;
  padding: 32px 24px;
  border-radius: 8px;
  margin-bottom: 48px;
`;

const FounderHeader = styled.div`
  display: flex;
  align-items: center;
  gap: 20px;
  margin-bottom: 20px;

  @media (max-width: 600px) {
    flex-direction: column;
    text-align: center;
  }
`;

const FounderPhoto = styled.img`
  width: 100px;
  height: 100px;
  border-radius: 50%;
  object-fit: cover;
  flex-shrink: 0;
  border: 3px solid #2d5a27;
`;

const FounderInfo = styled.div``;

const FounderName = styled.h3`
  font-size: 1.1rem;
  font-weight: 700;
  margin: 0 0 4px 0;
  color: #1a1a2e;
`;

const FounderRole = styled.p`
  font-size: 0.85rem;
  color: #2d5a27;
  margin: 0;
  font-weight: 600;
`;

const FounderBio = styled.div`
  font-size: 0.9rem;
  line-height: 1.7;
  color: #444;

  p {
    margin-bottom: 14px;

    &:last-child {
      margin-bottom: 0;
    }
  }
`;

const ValuesSection = styled.div`
  margin-bottom: 48px;
`;

const ValuesGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(260px, 1fr));
  gap: 16px;
  margin-top: 24px;
`;

const ValueCard = styled.div`
  background: #ffffff;
  padding: 24px 20px;
  border-radius: 8px;
  border: 1px solid #e0e0e0;
  transition: transform 0.2s ease, box-shadow 0.2s ease;

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
  }
`;

const ValueIcon = styled.div`
  width: 40px;
  height: 40px;
  background: #2d5a27;
  color: white;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 0.85rem;
  font-weight: 700;
  margin-bottom: 12px;
`;

const ValueTitle = styled.h4`
  font-size: 0.95rem;
  font-weight: 600;
  margin-bottom: 8px;
  color: #1a1a2e;
`;

const ValueDescription = styled.p`
  font-size: 0.85rem;
  line-height: 1.5;
  color: #666;
  margin: 0;
`;

const ProblemSection = styled.div`
  background: #fff8f8;
  border-left: 3px solid #d32f2f;
  padding: 24px;
  border-radius: 0 8px 8px 0;
  margin-bottom: 24px;
`;

const ProblemTitle = styled.h4`
  font-size: 0.95rem;
  font-weight: 600;
  color: #d32f2f;
  margin: 0 0 12px 0;
`;

const ProblemText = styled.p`
  font-size: 0.85rem;
  line-height: 1.6;
  color: #555;
  margin: 0;
`;

const SolutionSection = styled.div`
  background: #f1f8e9;
  border-left: 3px solid #2d5a27;
  padding: 24px;
  border-radius: 0 8px 8px 0;
  margin-bottom: 24px;
`;

const SolutionTitle = styled.h4`
  font-size: 0.95rem;
  font-weight: 600;
  color: #2d5a27;
  margin: 0 0 12px 0;
`;

const SolutionText = styled.p`
  font-size: 0.85rem;
  line-height: 1.6;
  color: #555;
  margin: 0;
`;

const MissionSection = styled.div`
  background: #f8f9fa;
  padding: 32px 24px;
  border-radius: 8px;
  text-align: center;
  margin-bottom: 48px;
`;

const MissionTitle = styled.h3`
  font-size: 1.1rem;
  font-weight: 700;
  margin-bottom: 12px;
  color: #1a1a2e;
`;

const MissionText = styled.p`
  font-size: 0.9rem;
  line-height: 1.6;
  color: #555;
  max-width: 600px;
  margin: 0 auto;
`;

const FAQSection = styled.div`
  margin-bottom: 48px;
`;

const FAQList = styled.div`
  max-width: 700px;
  margin: 24px auto 0 auto;
`;

const FAQItem = styled.div`
  border-bottom: 1px solid #eee;

  &:last-child {
    border-bottom: none;
  }
`;

const FAQQuestion = styled.button`
  width: 100%;
  padding: 14px 0;
  text-align: left;
  background: none;
  border: none;
  font-size: 0.9rem;
  font-weight: 600;
  color: #333;
  cursor: pointer;
  display: flex;
  justify-content: space-between;
  align-items: center;

  &:hover {
    color: #2d5a27;
  }
`;

const FAQAnswer = styled.div`
  padding: 0 0 14px 0;
  color: #666;
  line-height: 1.6;
  font-size: 0.85rem;
`;

const CTASection = styled.div`
  background: #f8f9fa;
  padding: 40px 16px;
  text-align: center;
`;

const CTAContainer = styled.div`
  max-width: 600px;
  margin: 0 auto;
`;

const CTATitle = styled.h2`
  font-size: 1.25rem;
  font-weight: 700;
  margin-bottom: 12px;
  color: #1a1a2e;
`;

const CTADescription = styled.p`
  font-size: 0.9rem;
  margin-bottom: 24px;
  color: #666;
  line-height: 1.5;
`;

const CTAButton = styled.button`
  background: #2d5a27;
  color: #ffffff;
  border: none;
  padding: 12px 32px;
  font-size: 0.95rem;
  font-weight: 600;
  border-radius: 6px;
  cursor: pointer;
  transition: all 0.2s ease;

  &:hover {
    background: #1f3d1b;
    transform: translateY(-1px);
  }
`;

const About = ({ user }) => {
  const [openFAQ, setOpenFAQ] = useState(null);

  const handleGetStarted = () => {
    if (user) {
      window.location.href = '/dashboard';
    } else {
      window.location.href = '/register';
    }
  };

  return (
    <Container>
      <HeroSection>
        <HeroContent>
          <PageTitle>About ShowingBooker</PageTitle>
          <PageSubtitle>
            Built by a Los Angeles real estate professional who was tired of bureaucratic red tape
            and wanted a better way to manage tenant-occupied property showings.
          </PageSubtitle>
        </HeroContent>
      </HeroSection>

      <ContentSection>
        <FounderSection>
          <FounderHeader>
            <FounderPhoto src="/david-bramante.png" alt="David Bramante, Founder & CEO" />
            <FounderInfo>
              <FounderName>David Bramante</FounderName>
              <FounderRole>Founder & CEO</FounderRole>
            </FounderInfo>
          </FounderHeader>
          <FounderBio>
            <p>
              After years as a licensed California real estate professional managing tenant-occupied properties
              in Los Angeles, I experienced firsthand the frustration of coordinating showings with difficult
              or uncommunicative tenants. The endless phone calls, the scheduling conflicts, the legal compliance
              headaches...it was a problem begging for a solution.
            </p>
            <p>
              Los Angeles has some of the most tenant-protective housing regulations in the country. The LA Housing
              Department, along with various city and state agencies, has created a complex web of requirements
              that property owners must navigate carefully. California Civil Code Section 1954 mandates specific
              notice requirements before entering tenant-occupied units (and the consequences of non-compliance
              can be severe).
            </p>
            <p>
              I founded ShowingBooker in 2025 to solve a multi-tiered problem: how do you efficiently schedule
              showings while respecting tenant rights, maintaining legal compliance, and documenting everything
              for potential disputes? The answer was to create a third-party tracking system that benefits everyone.
            </p>
            <p>
              For property owners, ShowingBooker provides instant booking, automated legal notices, and complete
              audit trails. For tenants, it offers transparency and respect...exchanging the broad "normal business
              hours" requirement for specific, limited time windows that work for their schedules. It's a win-win
              that transforms an adversarial process into a professional one.
            </p>
            <p>
              Today, ShowingBooker is 100% free for property owners, managers, and landlords. Our mission is to
              make legal compliance accessible to everyone, not just those who can afford expensive property
              management software like AppFolio. Fast, simple, and effective...that's what we built.
            </p>
          </FounderBio>
        </FounderSection>

        <StorySection>
          <SectionTitle>The Problem We Solve</SectionTitle>

          <ProblemSection>
            <ProblemTitle>The Challenge</ProblemTitle>
            <ProblemText>
              Managing showings for tenant-occupied properties is uniquely challenging. You're juggling
              legal notice requirements, tenant schedules, buyer/renter availability, and documentation...
              all while trying to avoid complaints to housing authorities. One mistake can result in
              harassment claims, legal liability, or regulatory action.
            </ProblemText>
          </ProblemSection>

          <SolutionSection>
            <SolutionTitle>Our Solution</SolutionTitle>
            <SolutionText>
              ShowingBooker automates the entire process. Schedule a showing, and the system automatically
              sends compliant 24-hour notices via SMS, email, and certified mail. Every interaction is logged
              with timestamps. If a tenant ever claims harassment, you have a complete audit trail proving
              you followed the law. It's not just convenient...it's protection.
            </SolutionText>
          </SolutionSection>
        </StorySection>

        <ValuesSection>
          <SectionTitle>Why ShowingBooker</SectionTitle>
          <ValuesGrid>
            <ValueCard>
              <ValueIcon>LA</ValueIcon>
              <ValueTitle>Built for LA Compliance</ValueTitle>
              <ValueDescription>
                Designed by someone who has navigated LA tenant law, city audits, and housing department
                requirements in one of America's most challenging rental markets.
              </ValueDescription>
            </ValueCard>

            <ValueCard>
              <ValueIcon>AT</ValueIcon>
              <ValueTitle>Complete Audit Trails</ValueTitle>
              <ValueDescription>
                Every notice, every delivery confirmation, every tenant response...documented and
                exportable as professional compliance reports.
              </ValueDescription>
            </ValueCard>

            <ValueCard>
              <ValueIcon>$0</ValueIcon>
              <ValueTitle>100% Free</ValueTitle>
              <ValueDescription>
                No monthly fees, no per-property charges, no hidden costs. Professional compliance
                tools shouldn't require an enterprise budget.
              </ValueDescription>
            </ValueCard>

            <ValueCard>
              <ValueIcon>++</ValueIcon>
              <ValueTitle>Fast & Simple</ValueTitle>
              <ValueDescription>
                Set up your first property in minutes. No complex onboarding, no training required.
                It just works.
              </ValueDescription>
            </ValueCard>

            <ValueCard>
              <ValueIcon>WW</ValueIcon>
              <ValueTitle>Win-Win for Everyone</ValueTitle>
              <ValueDescription>
                Tenants get respect and specific time windows. Owners get compliance and documentation.
                Everyone wins.
              </ValueDescription>
            </ValueCard>

            <ValueCard>
              <ValueIcon>3P</ValueIcon>
              <ValueTitle>Third-Party Documentation</ValueTitle>
              <ValueDescription>
                When disputes arise, having a neutral third-party system with timestamped records
                is invaluable.
              </ValueDescription>
            </ValueCard>
          </ValuesGrid>
        </ValuesSection>

        <MissionSection>
          <MissionTitle>Our Mission</MissionTitle>
          <MissionText>
            To make legal compliance simple and accessible for every property owner, manager, and landlord...
            transforming the showing process from a source of stress into a professional, documented,
            and compliant experience.
          </MissionText>
        </MissionSection>

        <FAQSection>
          <SectionTitle>Common Questions</SectionTitle>
          <FAQList>
            <FAQItem>
              <FAQQuestion onClick={() => setOpenFAQ(openFAQ === 1 ? null : 1)}>
                Why is ShowingBooker free? {openFAQ === 1 ? '−' : '+'}
              </FAQQuestion>
              {openFAQ === 1 && (
                <FAQAnswer>
                  We believe compliance tools should be accessible to everyone, not just large property
                  management companies. We're exploring sustainable revenue models that don't burden
                  property owners.
                </FAQAnswer>
              )}
            </FAQItem>

            <FAQItem>
              <FAQQuestion onClick={() => setOpenFAQ(openFAQ === 2 ? null : 2)}>
                How does ShowingBooker ensure compliance? {openFAQ === 2 ? '−' : '+'}
              </FAQQuestion>
              {openFAQ === 2 && (
                <FAQAnswer>
                  Our system automatically enforces 24-hour notice requirements, sends notifications
                  via multiple channels (SMS, email, certified mail), and creates timestamped records
                  of all communications...exactly what you need for California Civil Code Section 1954
                  compliance.
                </FAQAnswer>
              )}
            </FAQItem>

            <FAQItem>
              <FAQQuestion onClick={() => setOpenFAQ(openFAQ === 3 ? null : 3)}>
                How is this different from AppFolio or other property management software? {openFAQ === 3 ? '−' : '+'}
              </FAQQuestion>
              {openFAQ === 3 && (
                <FAQAnswer>
                  ShowingBooker is laser-focused on one thing: compliant showing management. We're not
                  trying to be a full property management suite. This focus means we're simpler, faster,
                  and free...while doing one thing exceptionally well.
                </FAQAnswer>
              )}
            </FAQItem>

            <FAQItem>
              <FAQQuestion onClick={() => setOpenFAQ(openFAQ === 4 ? null : 4)}>
                Can I use ShowingBooker for properties outside California? {openFAQ === 4 ? '−' : '+'}
              </FAQQuestion>
              {openFAQ === 4 && (
                <FAQAnswer>
                  Yes. While we're built with California's strict requirements in mind, the platform
                  works for properties anywhere. Our compliance features meet or exceed requirements
                  in most jurisdictions.
                </FAQAnswer>
              )}
            </FAQItem>
          </FAQList>
        </FAQSection>
      </ContentSection>

      <CTASection>
        <CTAContainer>
          <CTATitle>Ready to Simplify Your Showings?</CTATitle>
          <CTADescription>
            Join property owners and managers who trust ShowingBooker for compliant,
            documented, hassle-free showing management.
          </CTADescription>
          <CTAButton onClick={handleGetStarted}>
            {user ? 'Go to Dashboard' : 'Get Started Free'}
          </CTAButton>
        </CTAContainer>
      </CTASection>

      <Footer />
    </Container>
  );
};

export default About;
